import { render, staticRenderFns } from "./WebSourceManagementOverviewTable.vue?vue&type=template&id=472d00a6&scoped=true&"
import script from "./WebSourceManagementOverviewTable.vue?vue&type=script&lang=js&"
export * from "./WebSourceManagementOverviewTable.vue?vue&type=script&lang=js&"
import style0 from "./WebSourceManagementOverviewTable.vue?vue&type=style&index=0&id=472d00a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472d00a6",
  null
  
)

/* custom blocks */
import block0 from "./WebSourceManagementOverviewTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('472d00a6')) {
      api.createRecord('472d00a6', component.options)
    } else {
      api.reload('472d00a6', component.options)
    }
    module.hot.accept("./WebSourceManagementOverviewTable.vue?vue&type=template&id=472d00a6&scoped=true&", function () {
      api.rerender('472d00a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/web-source-management/WebSourceManagementOverviewTable.vue"
export default component.exports